import {Notification} from "./models";

export enum notificationsEvents {
    addBanner = 'notifications/addBanner',
}

const addBanner = function (bannerInfo: Notification[]) {
    const event = new CustomEvent('notifications/addBanner', {
        detail: bannerInfo,
    });
    window.dispatchEvent(event);
};

export default {
    addBanner,
};
